import React, { FC, MouseEvent, ReactNode } from 'react'
import {
  StyledButton,
  ButtonText,
  ButtonTextLight,
  ButtonTextSmall,
  IconArrowWrapper,
  IconLoadingWrapper,
  ButtonContent,
} from './styled'
import { Icon } from 'components/base-ui'

export interface ButtonProps {
  fill?: 'filled' | 'outlined'
  size?: 'large' | 'small'
  row?: 'one' | 'two'
  icon?: ReactNode
  arrow?: boolean
  loading?: boolean
  color?: 'primary' | 'success'
  block?: boolean
  text?: string
  textRow2?: string
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
}

const ButtonV2: FC<ButtonProps> = ({
  text = '',
  textRow2 = '',
  fill = 'filled',
  size = 'large',
  row = 'one',
  icon,
  arrow = false,
  color = 'primary',
  loading = false,
  onClick,
}) => {
  return (
    <StyledButton
      fill={fill}
      size={size}
      row={row}
      arrow={arrow}
      icon={icon}
      color={color}
      loading={loading}
      disabled={loading}
      onClick={onClick}
    >
      <ButtonContent>
        {icon}
        {size === 'large' && fill === 'filled' && (
          <ButtonText>
            {text}
            {textRow2 && (
              <>
                <br />
                {textRow2}
              </>
            )}
          </ButtonText>
        )}
        {size === 'large' && fill === 'outlined' && (
          <ButtonText>
            {text}
            {textRow2 && (
              <>
                <br />
                <ButtonTextLight>{textRow2}</ButtonTextLight>
              </>
            )}
          </ButtonText>
        )}
        {size === 'small' && (
          <ButtonTextSmall>
            {text}
            {textRow2 && (
              <>
                <br />
                {textRow2}
              </>
            )}
          </ButtonTextSmall>
        )}
        {arrow && (
          <IconArrowWrapper>
            <Icon name="arrow-right" size={size === 'large' ? '16px' : '14px'} />
          </IconArrowWrapper>
        )}
      </ButtonContent>

      <IconLoadingWrapper>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          className="lds-rolling"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            ng-attr-stroke="{{config.color}}"
            ng-attr-stroke-width="{{config.width}}"
            ng-attr-r="{{config.radius}}"
            ng-attr-stroke-dasharray="{{config.dasharray}}"
            stroke="#fff"
            strokeWidth="8"
            r="42"
            strokeDasharray="164.93361431346415 56.97787143782138"
            transform="rotate(162 50 50)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="400ms"
              begin="0s"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
        </svg>
      </IconLoadingWrapper>
    </StyledButton>
  )
}

export default ButtonV2
